import { createSelector } from 'reselect';
import { get } from 'lodash';
import { getWidgetConfig } from 'root/selectors';
import {
  getTabContext,
  selectTabContextItems,
  selectTabIsIdSelected,
  selectTabReachedMaxSelectionWithContext,
  selectTabCurrentContext,
  selectTabMultipleIdsInRange,
  selectTabAvailableUntilMax,
} from '../../common/selectors';
import { selectBatchStartCounter } from '../../../root/selectors';

const TAB = 'dropbox';

const getDropboxContext = getTabContext(TAB);
const selectContextItems = selectTabContextItems(TAB);
const selectReachedMaxSelection = selectTabReachedMaxSelectionWithContext(TAB);
const selectIsIdSelected = selectTabIsIdSelected(TAB);
const selectCurrentContext = selectTabCurrentContext(TAB);
const selectMultipleIdsInRange = selectTabMultipleIdsInRange(TAB);
const selectAvailableUntilMax = selectTabAvailableUntilMax(TAB);

const getSearchTerm = (state) => ({ searchTerm: state.dropbox.searchTerm });

const selectTabData = createSelector(
  getWidgetConfig,
  (state) => ({
    isLoggedIn: !!state.dropbox.token,
    searchTerm: getSearchTerm(state).searchTerm,
    currentContext: getDropboxContext(state).context,
    account: state.dropbox.account,
  }),
  selectBatchStartCounter,
  (widgetConfig, dbData, batchStartCounter) => ({
    cloudName: widgetConfig.cloudName,
    isMultiple: widgetConfig.multiple,
    isLoggedIn: dbData.isLoggedIn,
    currentContext: dbData.currentContext,
    searchTerm: dbData.searchTerm,
    userName: get(dbData, 'account.result.name.familiar_name'),
    batchStartCounter,
  })
);

const selectAuthData = createSelector(
  getWidgetConfig,
  (state) => state.dropbox.token,
  (widgetConfig, token) => ({
    token,
    cloudName: widgetConfig.cloudName,
  })
);

const selectSearchTerm = createSelector(getSearchTerm, (searchData) => searchData);

const selectExtDropboxKey = createSelector(getWidgetConfig, (config) => config.dropboxAppKey);

const selectContextSelectedItems = createSelector(selectContextItems, (data) => data.items.filter((item) => ~data.selected.indexOf(item.id)));

export {
  selectAuthData,
  selectTabData,
  selectContextItems,
  selectSearchTerm,
  selectIsIdSelected,
  selectReachedMaxSelection,
  selectCurrentContext,
  selectExtDropboxKey,
  selectMultipleIdsInRange,
  selectAvailableUntilMax,
  selectContextSelectedItems,
};
